module.exports = __webpack_public_path__ + "img/dashboard-icon3.be429a32.svg";